import { render, staticRenderFns } from "./NavbarNew.vue?vue&type=template&id=31a9b668&scoped=true"
import script from "./NavbarNew.vue?vue&type=script&lang=js"
export * from "./NavbarNew.vue?vue&type=script&lang=js"
import style0 from "./NavbarNew.vue?vue&type=style&index=0&id=31a9b668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a9b668",
  null
  
)

export default component.exports